import {
  DEFAULT_LANG,
  isPortalLanguage,
  LANGUAGES,
  PortalLanguage,
} from "common/i18nConstants";

/** Crop `name` is English; translations are every other portal language. */
export type CarbonCropTranslationLanguage = Exclude<
  PortalLanguage,
  typeof DEFAULT_LANG
>;

export const isCarbonCropTranslationLanguage = (
  language: string
): language is CarbonCropTranslationLanguage =>
  isPortalLanguage(language) && language !== DEFAULT_LANG;

export const CARBON_CROP_TRANSLATION_LANGUAGES = LANGUAGES.filter(
  (language): language is CarbonCropTranslationLanguage =>
    isCarbonCropTranslationLanguage(language)
);

/**
 * Returns the crop's translation for the given portal language, falling back
 * to the English `name` when there is none (or it was saved empty).
 **/
export const getLocaleCarbonCropName = (
  crop: {
    name: string;
    translations: { language: string; translation: string }[];
  },
  language: PortalLanguage
): string =>
  crop.translations.find((entry) => entry.language === language)?.translation ||
  crop.name;
